import React from "react";
import Logo from "./Files/Logo.png";
import Insta from "./Files/Instagram_Glyph_White.png";
import "./Components.css";

const Footer = () => {
    return (
        <footer className="modern-footer">

            <div className="footer-top">

                <a href="/" className="footer-logo">
                    <img src={Logo} alt="Laura Zaugg Logo" />
                </a>

                <div className="footer-links">
                    <a href="/">Home</a>
                    <a href="/aboutme">About</a>
                    <a href="/blog">Reisen</a>
                </div>

                <a
                    href="https://www.instagram.com/laurazaugg/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-social"
                >
                    <img src={Insta} alt="Instagram" />
                </a>

            </div>

            <div className="footer-bottom">
                <p>
                    © {new Date().getFullYear()} Laura Zaugg · Travel Blog
                </p>
            </div>

        </footer>
    );
};

export default Footer;